(ns practitest.frontend.common-entities.events
  (:require
    [ajax.core :as ajax]
    [cljs.core :as clj]
    [clojure.string :as str]
    [practitest.frontend.common-entities :refer [batch-navigate!
                                                 build-filter
                                                 build-grid-query
                                                 over-batch-limit]]
    [practitest.frontend.common-entities.metadata :refer [entities-metadata
                                                          get-entity-name]]
    [practitest.frontend.common.format-utils :as fu]
    [practitest.frontend.common.i18n :refer [format-translation
                                             get-translation]]
    [practitest.frontend.common.re-frame :refer [conditional-dispatch]]
    [practitest.frontend.components.grid.events :as grid.events]
    [practitest.frontend.components.grid.server :as server]
    [practitest.frontend.components.grid.subs :as grid.subs]
    [practitest.frontend.components.navigation :as navigation]
    [practitest.frontend.components.notifications :as notifications]
    [practitest.frontend.components2.entity-form :as entity-form]
    [practitest.frontend.components2.test-type :refer [automated-test-fields
                                                       automated-test-types
                                                       get-type-label]]
    [practitest.frontend.common.dom :as dom]
    [practitest.frontend.events :as events]
    [practitest.frontend.forms3.entity-form.forms :as forms3]
    [practitest.frontend.routing.backend-routes :as broutes]
    [practitest.frontend.routing.router :as router]
    [practitest.frontend.subs :as subs]
    [practitest.frontend.testset2.subs :as testset-subs]
    [practitest.frontend.version-updates.events :as version-events]
    [re-frame.core :as re-frame]
    [tick.core :as t]))

(defn- index-route-for [entity]
  (get-in entities-metadata [entity :routes :index]))

(defn on-index? [db entity]
  (and (= (:current-entity db) entity)
       (= (get-in db [:current-route :data :name]) (index-route-for entity))))

(defn push-to-index
  ([db entity] (push-to-index db entity {}))
  ([db entity query-params]
   [::router/push-state
    (index-route-for entity)
    {:project-id (subs/get-current-project-id db)}
    query-params]))

(defn entity-metadata [db]
  (get entities-metadata (:current-entity db)))

(defn merged-gridfilters [filter grid-query]
  (let [gridfilter-str (:gridfilter grid-query)
        gridfilter-map (when gridfilter-str
                         (clj/js->clj (js/JSON.parse gridfilter-str) :keywordize-keys true))
        merged (merge gridfilter-map (:gridfilter filter))]
    {:map merged
     :json (server/autofilters->json merged)}))

(defn fetch-entity-list [{db :db} [event-id grid-entity state-key grid-query]]
  (let [filter (get-in db [:entity (:current-entity db) state-key :current-filter-selected])
        filter-params (build-filter filter)
        {gf-map :map gf-json :json} (merged-gridfilters filter grid-query)
        grid-query (assoc grid-query :gridfilter gf-json)
        instance-view-mode? @(re-frame/subscribe [::testset-subs/instance-view-mode?])
        query-params (router/get-current-query-params)
        dashboard-item-id (:dashboard_item_id query-params)
        ptql (or (when (= grid-entity (get-in db [:project-assistant :active-ptql :entity]))
                   (get-in db [:project-assistant :active-ptql :query]))
                 (:ptql query-params))
        params (if ptql
                 (merge grid-query {:ptql ptql})
                 (merge filter-params grid-query
                        (when (and (= grid-entity :testset)
                                   (not= state-key :link-testsets-state))
                          {:instance_view_mode instance-view-mode?})
                        (when (and instance-view-mode? dashboard-item-id)
                          {:dashboard_item_id dashboard-item-id})
                        (when (= state-key :add-instances-state)
                          {:grid_columns_mode true})))
        project-id (subs/get-current-project-id db)
        url (get-in entities-metadata [grid-entity :urls :fetch-list])]
    {:db (update db :progress conj ::fetch-entity-list)
     :http-xhrio
     {:method          :get
      :uri             (broutes/get-url url {:p_id project-id})
      :format          :url
      :vec-strategy    :rails
      :params          params
      :response-format (ajax/json-response-format {:keywords? true})
      :on-success      [::got-entities state-key gf-map]
      :on-failure      [::events/api-error event-id {:message "Failed to fetch"}]}}))

(defn handle-fetch-success [db {:keys [data
                                       per_page
                                       current_page
                                       total_count
                                       full
                                       filter_columns]} state-key]
  (-> db
      (update-in [:entity (:current-entity db) state-key] assoc
                 ;; Selection uses this
                 ;; TODO: refactor this hidden dependency
                 :data data
                 :current-page current_page
                 :per-page per_page
                 :total-count total_count
                 :full-data? (boolean full)
                 ;; Sync filters
                 :filter-cols filter_columns
                 :current-filter-fetched (get-in db [:entity (:current-entity db) :current-filter-selected]))
      (update :progress disj ::fetch-entity-list)))
 ;; Helper function to update multiple grids with a selected view (filter or folder)
(defn- update-view-for-grids [db state-key view-type view-value]
 (let [current-entity (:current-entity db)
       view-key (case view-type
                  :filter :current-filter-selected
                  :folder :current-folder-selected)
       tab-value (case view-type
                   :filter "filters"
                   :folder "folders")]
   (-> db
       (assoc-in [:entity current-entity state-key view-key] view-value)
       (assoc-in [:entity current-entity state-key :current-tab] tab-value))))


(defn set-current-filter [{db :db}
                          [_ grid-entity state-key fetch-event grid-state filter user-action?]]
  (let [db-with-filter (update-view-for-grids db state-key :filter filter)]
    {:db db-with-filter
     :dispatch-n [[::grid.events/clear-selection [grid-entity state-key]]
                  [fetch-event
                   grid-entity
                   state-key
                   (server/build-query {:local-state-updating grid-state
                                        :fields (:fields db)}
                                       (if user-action?
                                         1
                                         (or (:current-page @grid-state) 1)))]]}))

(defn set-current-folder [{db :db}
                          [_ grid-entity state-key fetch-event grid-state folder]]
  (let [db-with-folder (update-view-for-grids db state-key :folder folder)]
    {:db db-with-folder
     :dispatch-n [[::grid.events/clear-selection [grid-entity state-key]]
                  [fetch-event
                   grid-entity
                   state-key
                   (server/build-query {:local-state-updating grid-state
                                        :fields (:fields db)} 1)]]}))

(defn fetch-grid-by-folder [{:keys [db]} [event-id grid-entity state-key grid-query]]
  (let [folder    (get-in db [:entity (:current-entity db) state-key :current-folder-selected])
        query-map {:folder (:id folder)} 
        instance-view-mode? @(re-frame/subscribe [::testset-subs/instance-view-mode?]) 
        query-map (merge query-map grid-query {:instance_view_mode instance-view-mode?}) 
        url (get-in entities-metadata [grid-entity :urls :fetch-list])]
    {:db (update db :progress conj event-id)
     :fx [[:http-xhrio {:method :get
                        :uri (broutes/get-url url
                                              {:p_id (subs/get-current-project-id db)})
                        :format :url
                        :vec-strategy :rails
                        :params query-map
                        :response-format (ajax/json-response-format {:keywords? true})
                        :on-success [::got-entities state-key nil]
                        :on-failure [::events/api-error event-id {}]}]]}))

(defn collect-form-params
  [entity-key form-state module-state all-fields]
  (let [dirty-fields-state (into {}
                                 (comp (filter (fn [[field field-state]]
                                                 (or (:dirty? field-state)
                                                     ;; Pass default values to server too - new form scenario
                                                     (:default-value field-state)
                                                     ;; Always pass name field to satisfy backend checks
                                                     ;; TODO: fix this on backend
                                                     (= :name field))))
                                       (map (fn [[field field-state]]
                                              [field (:value field-state)])))
                                 (:fields form-state))

        custom-fields (filter #(:custom? (get all-fields %)) (keys dirty-fields-state))
        system-fields (filter #(:system? (get all-fields %)) (keys dirty-fields-state))
        ;; special case for :name field
        system-fields (conj system-fields :name)
        user-fields (filter #(= :user (:type (get all-fields %))) custom-fields)

        automated-test-data   (select-keys dirty-fields-state automated-test-fields)
        dirty-fields-state    (apply dissoc dirty-fields-state automated-test-fields)

        params (merge {entity-key  (merge
                                     (select-keys dirty-fields-state system-fields)

                                     ;; Tags support
                                     (when (contains? dirty-fields-state :tags)
                                       {:all_tags_list (str/join "," (:tags dirty-fields-state))})

                                     ;; Special backend param to add instances
                                     (when-let [ids (:instances-to-add module-state)]
                                       {:new_form_starting_with_test_ids ids})

                                     ;; Special backend params for automated_test Test Type in Test Form
                                     (when-let [form-state-type (get-in form-state [:fields :test_type :value])]
                                       (let [form-state-type-downcase (str/lower-case (get-type-label form-state-type))
                                             automated? (or (contains? automated-test-types form-state-type)
                                                            (contains? automated-test-types (:test_type dirty-fields-state)))]
                                         (when automated?
                                         {:automated_test (merge automated-test-data
                                                {:is_automated_clicked true
                                                 :automation_type form-state-type-downcase}) })))
                                    
                                     ;; client_id for Suite/Instance (not handled by automated_test above)
                                     (when (and (contains? #{:suite :instance} entity-key)
                                                (contains? automated-test-data :client_id))
                                       {:client_id (:client_id automated-test-data)})

                                     ;; backend param to add requirement when added on new entity
                                     ;; id will be string when added from jira
                                     (when-let [ids (:linked_requirement_ids form-state)]
                                       {:linked_requirement_ids ids})

                                     ;; backend param to add issues when added on new entity
                                     (when-let [ids (:linked_issue_ids form-state)]
                                       {:linked_issue_ids ids})

                                     ;; backend param to add tests when added on new entity
                                     (when-let [ids (:test_ids form-state)]
                                       {:test_ids ids})

                                     ;; Assigned to field handling
                                     (events/process-assigned-to dirty-fields-state))

                       :custom (merge
                                 ;; user fields will be overwritten by subsequent merge
                                 (select-keys dirty-fields-state custom-fields)

                                 ;; Users fields handling (backend expects user id as a string in custom fields)
                                 (reduce (fn [acc key]
                                           (if (contains? dirty-fields-state key)
                                             (assoc acc key (str (or (:id (get dirty-fields-state key))
                                                                     (get dirty-fields-state key))))
                                             acc))
                                         {}
                                         user-fields))}

                      ;; Special handling for status field
                      (when-let [new-status (:issue_status dirty-fields-state)]
                        {:new_status new-status})

                      ;; Special handling for kanban lane
                      (when (contains? dirty-fields-state :kanban_lane)
                        (let [kanban (:kanban_lane dirty-fields-state)]
                          {:kanban (when kanban (:lane_id kanban))}))
                      {:current-entity entity-key})]
    params))

(re-frame/reg-fx
  ::batch-navigate!
  (fn [[path selection current-view optional-params]]
    (batch-navigate! path selection current-view optional-params)))

(re-frame/reg-event-fx
  ::batch-navigate
  (fn [_ [_ path selection current-view optional-params]]
    {::batch-navigate! [path selection current-view optional-params]}))

(defn batch-navigate-guarded
  "batch-navigate! that aborts with an error toast when the selection exceeds the batch limit."
  [{:keys [entity state-key path selection current-view optional-params]}]
  (let [n (if (= selection :_all)
            @(re-frame/subscribe [::grid.subs/entities-total-count entity state-key])
            (count selection))]
    (when-not (over-batch-limit n)
      (re-frame/dispatch [::batch-navigate path selection current-view optional-params]))))

(re-frame/reg-fx
  ::fire-select-filter!
  (fn [view-id]
    (.dispatchEvent js/window (js/CustomEvent. "pt-select-filter" #js {:detail #js {:id view-id}}))))

(re-frame/reg-fx
  ::set-cv-query-param!
  (fn [view-id]
    (router/update-query-params! assoc :cv view-id)))

(re-frame/reg-event-fx
  ::activate-view
  (fn [{db :db} [_ entity view-id]]
    (if (on-index? db entity)
      {::set-cv-query-param! view-id
       ::fire-select-filter! view-id}
      {:dispatch (push-to-index db entity {:cv view-id})})))

;; Delete entity event
(re-frame/reg-event-fx
  ::delete-entity
  (fn [{db :db} [_ id state-key grid-state]]
    (let [route-name (get-in (entity-metadata db) [:urls :delete])
          delete-entities-url (broutes/get-url route-name
                                               {:p_id (subs/get-current-project-id db)
                                                :id id})]
      {:http-xhrio
       {:method :delete
        :uri    delete-entities-url
        :format          (ajax/json-request-format)
        :response-format (ajax/json-response-format {:keywords? true})
        :on-success [::entity-deleted state-key grid-state]
        :on-failure [::entity-deleted-error]}})))

; Handle success
(re-frame/reg-event-fx
 ::entity-deleted
 (fn [{db :db} [_ state-key grid-state]]
   (let [entity (:current-entity db)
         current-tab (get-in db [:entity entity state-key :current-tab])
         grid-query (server/build-query {:local-state-updating grid-state} 1)
         entity-name (get-entity-name entity :singular-name)]
     {:dispatch-n [(if (= current-tab "filters")
                     [::fetch-entity-list entity state-key grid-query]
                     [::fetch-entity-list-by-folder entity state-key grid-query])
                   [::notifications/success2 (get-translation (str (name entity) ".notify.deleted")
                                                              (str entity-name " was successfully deleted"))]]})))

; Handle error
(re-frame/reg-event-fx
  ::entity-deleted-error
  (fn [{db :db} _]
    (let [entity (:current-entity db)
          entity-name (get-entity-name entity :singular-name)]
      {:dispatch [::notifications/error2
                  (get-translation (str (name entity) ".notify.error-deleting") (str "Error deleting " entity-name))
                  {:id "api-error-message"}]})))

(re-frame/reg-event-fx
  ::fetch-entity-list-by-folder
  fetch-grid-by-folder)

(re-frame/reg-event-fx
  ::fetch-entity-list
  fetch-entity-list)

(re-frame/reg-event-fx
  ::got-entities
  (fn [{:keys [db]} [_ state-key autofilters response]]
    {:db (handle-fetch-success db response state-key)
     :fx [[:dispatch [::refresh-effective-ptql state-key autofilters]]]}))

(defn- extract-cv-id [{:keys [id]}]
  (cond
    (integer? id) id
    (string? id) (let [head (first (str/split id #"/"))
                       n (js/parseInt head 10)]
                   (when-not (js/isNaN n) n))))

(defn- fetch-effective-ptql [project-id cv-id params on-success on-failure]
  {:http-xhrio
   {:method          :get
    :uri             (broutes/get-url "custom_views#effective_ptql" {:project_id project-id :id cv-id})
    :params          params
    :format          (ajax/url-request-format :rails)
    :vec-strategy    :rails
    :response-format (ajax/json-response-format {:keywords? true})
    :on-success      on-success
    :on-failure      on-failure}})

(re-frame/reg-event-fx
 ::refresh-effective-ptql
 (fn [{:keys [db]} [_ state-key fast-filters]]
   (when (get-in db [:options :ptql-debug-bar-enabled?])
     (let [current-entity (:current-entity db)
           assistant-ptql (when (= current-entity (get-in db [:project-assistant :active-ptql :entity]))
                            (get-in db [:project-assistant :active-ptql :query]))
           cv             (get-in db [:entity current-entity state-key :current-filter-selected])
           cv-id          (extract-cv-id cv)
           project-id     (subs/get-current-project-id db)]
       (cond
         assistant-ptql
         {:fx [[:dispatch [::store-effective-ptql current-entity state-key 
                           {:ptql assistant-ptql
                            :source :assistant}]]]}

         (integer? cv-id)
         (fetch-effective-ptql
          project-id cv-id
          (cond-> {}
            (seq (:auto_filter cv)) (assoc :auto_filter (remove nil? (:auto_filter cv)))
            (seq fast-filters)      (assoc :fast_filters fast-filters))
          [::store-effective-ptql current-entity state-key]
          [::store-effective-ptql current-entity state-key {:ptql ""}])

         :else
         {:fx [[:dispatch [::store-effective-ptql current-entity state-key {:ptql ""}]]]})))))

(re-frame/reg-event-db
 ::store-effective-ptql
 (fn [db [_ current-entity state-key {:keys [ptql source]}]]
   (-> db
       (assoc-in [:entity current-entity state-key :ptql] (or ptql ""))
       (assoc-in [:entity current-entity state-key :ptql-source] (or source :custom-view)))))

(re-frame/reg-event-fx
 ::copy-effective-ptql
 (fn [{:keys [db]} [_ filter-id auto-filter-values]]
   (let [project-id (subs/get-current-project-id db)
         cv-id      (extract-cv-id {:id filter-id})]
     (when (integer? cv-id)
       (fetch-effective-ptql
        project-id cv-id
        (cond-> {}
          (seq auto-filter-values)
          (assoc :auto_filter (vec auto-filter-values)))
        [::copy-effective-ptql-success]
        [::copy-effective-ptql-failure])))))

(re-frame/reg-event-fx
 ::copy-effective-ptql-success
 (fn [_ [_ {:keys [ptql]}]]
   (when (seq ptql)
     (dom/text->clipboard ptql)
     {:dispatch [::notifications/success2 (get-translation "filters-tree.context-menu.ptql-copied" "PTQL copied to clipboard")]})))

(re-frame/reg-event-fx
 ::copy-effective-ptql-failure
 (fn [_ _]
   {:dispatch [::notifications/error2 (get-translation "filters-tree.context-menu.ptql-copy-failed" "Failed to copy PTQL")]}))

(re-frame/reg-event-fx
 ::set-current-folder
 set-current-folder)

(re-frame/reg-event-fx
 ::set-current-filter
 set-current-filter)

(re-frame/reg-event-fx
  :move-entities-to-folder
  (fn [{:keys [db]} [_ state-key grid-state folder-id rows entity-type]]
    (let [entity-key (keyword (clojure.string/lower-case entity-type))
          grid-key (get subs/index-grid-keys entity-key)
          selection (get-in db [:entity entity-key grid-key :selection])
          total-count (get-in db [:entity entity-key grid-key :total-count])
          current-folder (get-in db [:entity entity-key grid-key :current-folder-selected :id])
          ids (map :id rows)]
      (if (or (and (= selection :_all) (> total-count 100))
              (> (count ids) 100))
          {:dispatch [::notifications/error2 (get-translation "folders.drag.move-entities-limit" "Cannot move more than 100 items at once")]}
          {:http-xhrio
            {:method :post
              :uri (broutes/get-url
                             "folders#move_entities_to_folder"
                             {:project_id (-> db :current-project :id)
                              :folder_id  folder-id})
              :params {:ids ids :entity_type entity-type :selection selection :current_folder current-folder }
              :format (ajax/json-request-format)
              :response-format (ajax/json-response-format {:keywords? true})
              :on-success [:move-entities-success state-key entity-key grid-state]
              :on-failure [:move-entities-failure]}}))))

(re-frame/reg-event-fx
  :move-entities-success
  (fn [{:keys [db]} [_ state-key entity-key grid-state response]]
    (let [grid-query (server/build-query {:local-state-updating grid-state} 1)]
      (if response
        {:dispatch-n [[::notifications/success2 (format-translation (get-translation "folders.drag.move-entities-success" response)
                                              {:n (response :moved)})]
                                              [::fetch-entity-list-by-folder entity-key state-key grid-query]]}))))

(re-frame/reg-event-fx
  :move-entities-failure
  (fn [_ [_ error]]
    {:dispatch [::notifications/error2 (format-translation (get-translation "folders.drag.move-entities-error" error)
                                                            {:n (error :moved)})]}))

(defn toggle-link-entities-modal [db
                                  [_ grid-entity state-key fetch-event per-page-grid-load]]
  (let [new-show? (not (get-in db [:entity (:current-entity db) state-key :show-link-entities-modal?]))
        filter {:id "_DEFAULT_"}
        per_page (when (fn? per-page-grid-load)
                   (per-page-grid-load))
        per_page (or per_page server/default-per-page)
        query (merge server/default-query {:per_page per_page})
        merged-db {:db (-> db
                           (assoc-in [:entity (:current-entity db) state-key]
                                     {:show-link-entities-modal? new-show?
                                      :current-page 1
                                      :selected-entities #{}
                                      :current-filter-selected filter}))}]
    (if new-show?
      (assoc merged-db :dispatch [fetch-event grid-entity state-key query])
      merged-db)))

(re-frame/reg-event-fx
  ::toggle-link-entities-modal
  (fn [{:keys [db]} data]
    (toggle-link-entities-modal db data)))

(defn- reset-table-expanded
  [db current-entity state-key]
  (let [was-expanded? (get-in db [current-entity state-key :expanded?])]
    (cond-> db
      ;; Toggle expanded mode off
      true
      (assoc-in [current-entity state-key :expanded?] false)

      ;; Only restore project-level menu state if we were actually in expanded mode
      was-expanded?
      (navigation/set-project-level-menu-collapsed (get-in db [current-entity state-key :project-level-menu-collapsed?])))))

(re-frame/reg-event-fx
  ::toggle-expanded
  (fn [{db :db} [_ current-entity state-key]]
    (let [new-expanded? (not (grid.subs/get-table-expanded? db current-entity state-key))]
      {:db (if new-expanded?
             (-> db
                 (assoc-in [current-entity state-key :expanded?] new-expanded?)
                 ;; Store old status of project-level menu (to restore back on expand click)
                 (assoc-in [current-entity state-key :project-level-menu-collapsed?] (navigation/project-level-menu-collapsed? db))
                 ;; Set collapsed status directly to avoid storing it in local storage (so it will be reset on page reload)
                 (navigation/set-project-level-menu-collapsed true))
             (reset-table-expanded db current-entity state-key))})))

(re-frame/reg-event-db
  ::reset-expanded
  (fn [db [_ current-entity state-keys]]
    (reduce (fn [db state-key]
              (reset-table-expanded db current-entity state-key))
            db
            (if (coll? state-keys) state-keys [state-keys]))))

(re-frame/reg-event-fx
  ::save-entity
  (fn [{db :db} [_ form-id entity-key {:keys [new? additional-params-helper route-params] :as options}]]
    (let [{:keys [urls]} (entity-metadata db)
          entity (:current-entity db)
          additional-params-helper (if (nil? additional-params-helper)
                                     (fn [db params]
                                       params)
                                     additional-params-helper)
          staged-attachments (get-in db [:entity entity :attachments :stage])
          route (if new?
                  (broutes/get-route (:create urls) (merge {:p_id (subs/get-current-project-id db)}
                                                           route-params))
                  (broutes/get-route (:update urls) (merge {:p_id (subs/get-current-project-id db)
                                                            :id (subs/get-current-entity-id db entity)}
                                                           route-params)))]
      {:db (update db :progress conj ::save-entity)
       :http-xhrio
       {:method          (:method (:data route))
        :uri             (:path route)
        :params          (cond->
                           (additional-params-helper
                             db
                             (collect-form-params entity-key (get-in db [:form-states2 form-id])
                                                  (get-in db [:entity entity :module-state])
                                                  (:fields db)))
                           ;; Add staged-attachments if any
                           (seq staged-attachments)
                           (assoc :stage-attachments (into {} (map (juxt :id :name) staged-attachments)))
                           ;; Add AI text enhancement flag if used
                           (get-in db [:form-states2 form-id :ai-text-enhancement-used?])
                           (assoc :ai_text_enhancement_used true))
        :format          (ajax/json-request-format)
        :response-format (ajax/json-response-format {:keywords? true})
        :on-success      [::entity-saved entity form-id options]
        :on-failure      [::entity-save-error entity options]}})))

(re-frame/reg-event-fx
  ::entity-save-error
  (fn [{db :db} [_
                 entity-type
                 {:keys [new?]}
                 {:keys [response]}]]
    {:db       (-> db (update :progress disj ::save-entity))

     :dispatch [::notifications/error2 (if-let [errors (:errors response)]
                                         (fu/format-server-error-message errors)
                                         ;; use static message if no error is provided by server
                                         (let [entity-name (name entity-type)]
                                           (if new?
                                             (get-translation (str entity-name ".notify.error-creating") (str "Error creating " entity-name))
                                             (get-translation (str entity-name ".notify.error-saving") (str "Error saving " entity-name)))))
                {:id "api-error-message"}]}))

(re-frame/reg-event-fx
  ::entity-saved
  (fn [{db :db} [_ entity-type form-id {:keys [close?
                                               got-entity-data
                                               continue-testing?
                                               redirect-key
                                               new?]
                                        :as   options}
                 response]]
    (let [entity (:entity response)
          id (:id entity)
          {:keys [urls routes]} (entity-metadata db)
          state-key (subs/index-grid-keys entity-type)]

      (-> {:db (-> db
                   (update :progress disj ::save-entity)
                   (forms3/reset-form-state-with-entity entity form-id)
                   (update-in [:entity entity-type]
                              (fn [entity-data]
                                (let [base (-> (or entity-data {})
                                                   (assoc  :current  entity
                                                           :state    nil
                                                           :remote   nil
                                                           :editing? false))
                                      data (if new?
                                             []
                                             (get-in entity-data [state-key :data] []))]
                                  (assoc-in base [state-key :data] data)))))

           :fx (cond
                 close?
                 ;; Save and close - go back to testset if we came from one, otherwise go to index page
                 (let [url-params (js/URLSearchParams. (.-search js/window.location))
                       add-to-suite (when (.has url-params "add_to_suite") (.get url-params "add_to_suite"))
                       p-id (subs/get-current-project-id db)
                       params {:p_id p-id}
                       redirect-url (if add-to-suite
                                      (broutes/get-url "suites#edit" (assoc params :id add-to-suite))
                                      (broutes/get-url (:index urls) params))]
                   [[::events/redirect-delayed redirect-url]])

                 continue-testing?
                 ;; Fail & issue - save & continue testing
                 [[::events/redirect-delayed (:redirect_url response)]]

                 (and redirect-key (some? (get response redirect-key)))
                 [[::events/redirect-delayed (get response redirect-key)]]

                 :else
                 [[:dispatch-n [[::notifications/success2
                                 (let [entity-name (name entity-type)]
                                   (if new?
                                     (get-translation (str entity-name ".notify.created") (str entity-name " was successfully created"))
                                     (get-translation (str entity-name ".notify.saved") (str entity-name " was successfully saved"))))
                                 {:auto-close notifications/auto-close-success-timeout}]
                                [::events/fetch-history]
                                [::entity-form/set-notification-state
                                 form-id
                                 {:status     "success"
                                  :type       :saved
                                  :updated-at (t/now)
                                  :updated-by (:id (:current-user db))}]
                                (when new?
                                 ;; Back navigation doesn't really work here, so we're using replace-state
                                  [::router/replace-state (:edit routes) {(:entity-key routes) id}])

                                (when (:versioned response)
                                  ;; Navigate to the new version ID when versioning occurs and refresh entities list
                                  [::navigate-to-new-version-and-refresh (:new_id response) (:edit routes) (:entity-key routes)])

                                ;; Check if there's a critical version update and update display type
                                (when (= (get-in db [:version-update :display-type]) :critical-with-unsaved-changes)
                                  (notifications/dismiss "version-update-notification")
                                  [::version-events/update-version-update-display-type :critical-modal])]]])}
          (conditional-dispatch got-entity-data options response)))))

(re-frame/reg-event-fx
  ::navigate-to-new-version-and-refresh
  (fn [{:keys [db]} [_ new-id edit-route entity-key]]
    (let [entity-type (:current-entity db)
          state-key (subs/index-grid-keys entity-type)
          entity-state (get-in db [:entity entity-type state-key])
          current-page (:current-page entity-state)
          per-page (:per-page entity-state)
          project-id (subs/get-current-project-id db)
          table-id (get-in entities-metadata [entity-type :table-id])
          session-key (str project-id "-" table-id)
          grid-query (build-grid-query session-key per-page current-page)
          current-fragment (router/get-current-fragment-decoded)]
      {:fx [[:dispatch [::router/replace-state edit-route {entity-key new-id}]]
            [:dispatch [::fetch-entity-list entity-type state-key grid-query]]
            (when (:tab current-fragment)
                  [:dispatch-later [{:ms 10
                                     :dispatch [::restore-fragment-tab (:tab current-fragment)]}]])]})))

(re-frame/reg-event-fx
  ::restore-fragment-tab
  (fn [_ [_ tab]]
      (router/update-fragment! assoc :tab tab)
      {}))

(re-frame/reg-event-fx
  ::delete-current-entity
  (fn [{db :db} [_ entity-form-id]]
    (let [entity              (:current-entity db)
          entity-id           (subs/get-current-entity-id db entity)
          route-name          (get-in (entity-metadata db) [:urls :delete])
          delete-entities-url (broutes/get-url route-name
                                               {:p_id (subs/get-current-project-id db)
                                                :id entity-id})]
      {:http-xhrio
       {:method :delete
        :uri             delete-entities-url
        :format          (ajax/json-request-format)
        :response-format (ajax/json-response-format {:keywords? true})
        :on-success      [::current-entity-deleted entity-id entity-form-id]
        :on-failure      [::events/api-error ::delete {}]}})))

(re-frame/reg-event-fx
  ::current-entity-deleted
  (fn [{db :db} [_ entity-id entity-form-id]]
    (let [entity         (:current-entity db)
          entity-str     (name entity)
          entity-display (get-entity-name entity :singular-name)
          index-route    (get-in entities-metadata [entity :routes :index])]
      {:db         (update db entity dissoc entity-id)
       :dispatch-n [[::notifications/success2
                     (format-translation
                       (get-translation (str entity-str ".notify.deleted")
                                        (str entity-display " was successfully deleted")))
                     {:auto-close notifications/auto-close-success-timeout}]
                    [::entity-form/set-notification-state
                     entity-form-id
                     {:status     "success"
                      :type       :saved
                      :updated-at (t/now)
                      :updated-by (:id (:current-user db))}]
                    [::router/replace-state index-route]]})))


(re-frame/reg-event-fx
  ::trigger-online-request
  (fn [{:keys [db]} [_]]
    (let [location (.-href js/window.location)]
      {:http-xhrio {:method          :post
                    :uri             (broutes/get-url-view "sessions#online")
                    :params          {:location location
                                      :state    "active"}
                    :format          (ajax/json-request-format)
                    :response-format (ajax/json-response-format {:keywords? true})
                    :on-success      []
                    :on-failure      []}})))

(re-frame/reg-sub
  ::instances-limit
  (fn [db [_ entity-type]]
    (get-in db [:entity entity-type :instances_limit])))

(re-frame/reg-event-db
  ::set-history-filter
  (fn [db [_ filter]]
    (assoc db :history-filter filter)))

(re-frame/reg-sub
  ::history-filter
  (fn [db _]
    (:history-filter db)))
